<template>
    <v-list :dense="$vuetify.breakpoint.smAndDown" subheader>
        <template>
            <v-list-item to="/">
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        Dashboard
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider/>
            <v-subheader>Content Creator</v-subheader>
            <v-list-item :to="{path: '/creator/148'}">
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        doctupus
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{path: '/creator/158'}">
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        expanda
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{path: '/creator/2'}">
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        medLive
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{path: '/creator/218'}">
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        academy
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name: 'Creators'}">
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        Alle
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider/>
            <v-subheader>Benutzer</v-subheader>
            <v-list-item :to="{name: 'Users'}">
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        Verwaltung
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name: 'UserAnalysis'}">
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        Auswertung
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name: 'Orders'}">
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        Bestellungen
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider/>
            <v-list-item :to="{name: 'Sitemanagement'}">
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        Seitenmanagement
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name: 'Experts'}">
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        Experten
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name: 'CmeOverview'}">
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        CME
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <template v-if="can('marketing.view')">
                <v-list-item :to="{name: 'MarketingUserActivity'}">
                    <v-list-item-content>
                        <v-list-item-title class="subtitle-2 font-weight-regular">
                            Marketing
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
            <v-divider/>
            <v-list-item @click="onLogout">
                <v-list-item-icon class="mr-2">
                    <v-icon small>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="subtitle-2 font-weight-regular">
                        Abmelden
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-list>
</template>

<script>
import {mapGetters} from "vuex";
import {onLogout} from "@/plugins/vue-apollo";

export default {
    name: 'SuMenuList',
    data() {
        return {
            creators: true,
            menuItems: true,
        }
    },
    methods: {
        onLogout() {
            onLogout(this.$apollo.getClient())
        }
    },
    computed: {
        ...mapGetters('permissions', ['can']),
    },
};
</script>

<style scoped>
</style>
